module.exports = __webpack_public_path__ + "img/yaris.c3dbb694.png";